import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadoTarea',
  standalone: true
})
export class EstadoTareaPipe implements PipeTransform {

  transform(value: number): unknown {
    const estados = [          
      "ENELABORACION", 
      "RECIBIDO", 
      "ENVIADO", 
      "ELIMINADO", 
      "ARCHIVADO"
    ];
    return estados[value] || '';
  }

}
